const getShortenedString = ({ string, totalChars }) => {
  return `${string?.substr?.(0, totalChars || 20)}${string?.length > (totalChars || 20) ? "..." : ""}`.trim();
};

const getCommaFormattedPrice = (price) => {
  // Ensure the price is treated as a number.
  // If it's a string, parseFloat will convert it.
  // If it's already a number, it will remain a number.
  const numericPrice = parseFloat(price);

  // Check if the conversion resulted in a valid number.
  if (isNaN(numericPrice)) {
    console.error("Invalid price input. Please provide a number or a string that can be converted to a number.");
    return "Invalid Price"; // Or any other desired error handling
  }

  // Use toLocaleString to format the number with commas.
  // 'en-US' locale is commonly used for comma separation.
  // You can adjust the locale based on specific requirements (e.g., 'de-DE' for dot separation).
  return numericPrice.toLocaleString('en-US');
};

const getCommaFormattedNumber = (price) => {
  // Ensure the price is treated as a number.
  // If it's a string, parseFloat will convert it.
  // If it's already a number, it will remain a number.
  const numericPrice = parseFloat(price);

  // Check if the conversion resulted in a valid number.
  if (isNaN(numericPrice)) {
    console.error("Invalid price input. Please provide a number or a string that can be converted to a number.");
    return "Invalid Price"; // Or any other desired error handling
  }

  // Use toLocaleString to format the number with commas.
  // 'en-US' locale is commonly used for comma separation.
  // You can adjust the locale based on specific requirements (e.g., 'de-DE' for dot separation).
  return numericPrice.toLocaleString('en-US');
};

export {
  getShortenedString,
  getCommaFormattedPrice,
  getCommaFormattedNumber
};